import styled from '@emotion/styled';

const StyledSvg = styled.svg`
  display: block;
`;

export { StyledSvg };
